document.addEventListener('algolia.hooks.initialize', function() {

  // Fetch trending searches from Query Suggestions index
  (function() {
    var cfg = algoliaShopify.config || {};
    var appId = cfg.app_id;
    var apiKey = cfg.search_api_key;
    if (!appId || !apiKey) return;

    fetch('https://' + appId + '-dsn.algolia.net/1/indexes/production_shopify_products_query_suggestions/query', {
      method: 'POST',
      headers: {
        'X-Algolia-Application-Id': appId,
        'X-Algolia-API-Key': apiKey,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ query: '', hitsPerPage: 6 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (!data.hits || !data.hits.length) return;
      window.MNNav = window.MNNav || {};
      var algoliaItems = data.hits.map(function(hit) {
        return { text: hit.query, url: '/search?q=' + encodeURIComponent(hit.query) };
      });
      var pinned = window.MNNav.pinnedSearches || [];
      if (!pinned.length) {
        window.MNNav.trendingSearches = algoliaItems;
        return;
      }
      // Interleave: algolia, pinned, algolia, pinned... up to 6 items
      var merged = [];
      var ai = 0, pi = 0;
      while (merged.length < 6 && (ai < algoliaItems.length || pi < pinned.length)) {
        if (ai < algoliaItems.length) merged.push(algoliaItems[ai++]);
        if (merged.length < 6 && pi < pinned.length) merged.push(pinned[pi++]);
      }
      window.MNNav.trendingSearches = merged;
    })
    .catch(function() {});
  })();

  // Fetch trending products from Algolia Recommend API (fallback for empty recently viewed)
  (function() {
    var cfg = algoliaShopify.config || {};
    var appId = cfg.app_id;
    var apiKey = cfg.search_api_key;
    if (!appId || !apiKey) return;

    function mapHitsToProducts(hits) {
      return hits.map(function(hit) {
        var priceNum = parseFloat(hit.price);
        var price = '';
        if (!isNaN(priceNum) && priceNum > 0) {
          price = window.Shopify && window.Shopify.formatMoney
            ? window.Shopify.formatMoney(Math.round(priceNum * 100))
            : '$' + priceNum.toFixed(2).replace(/\.00$/, '');
        }
        var img = hit.image || '';
        if (!img && hit.product_image) {
          img = hit.product_image.indexOf('//') === 0 ? 'https:' + hit.product_image : hit.product_image;
        }
        return {
          title: hit.title || '',
          url: '/products/' + hit.handle,
          image: img,
          price: price
        };
      });
    }

    // Try Recommend Trending Items first
    fetch('https://' + appId + '-dsn.algolia.net/1/indexes/*/recommend', {
      method: 'POST',
      headers: {
        'X-Algolia-Application-Id': appId,
        'X-Algolia-API-Key': apiKey,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        requests: [{
          indexName: 'production_shopify_products',
          model: 'trending-items',
          maxRecommendations: 4,
          threshold: 0
        }]
      })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var hits = (data.results && data.results[0] && data.results[0].hits) || [];
      if (hits.length > 0) {
        window.MNNav = window.MNNav || {};
        window.MNNav.trendingProducts = mapHitsToProducts(hits);
        return;
      }
      // Fallback: simple empty-query search for top products by default ranking
      return fetch('https://' + appId + '-dsn.algolia.net/1/indexes/production_shopify_products/query', {
        method: 'POST',
        headers: {
          'X-Algolia-Application-Id': appId,
          'X-Algolia-API-Key': apiKey,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ query: '', hitsPerPage: 4, distinct: true })
      })
      .then(function(r) { return r.json(); })
      .then(function(fallbackData) {
        if (!fallbackData.hits || !fallbackData.hits.length) return;
        window.MNNav = window.MNNav || {};
        window.MNNav.trendingProducts = mapHitsToProducts(fallbackData.hits);
      });
    })
    .catch(function() {});
  })();

  // Helper function for debounce delay
  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  // Add 500ms debounce for autocomplete to reduce API calls
  algoliaShopify.hooks.registerHook('beforeAutocompleteAsyncFunction', async function() {
    await sleep(500);
  });

   // Force detached (overlay) mode on all screen sizes. On desktop the overlay
   // is restyled via CSS to appear as a full-width dropdown below the header
   // rather than a full-screen modal, preserving suggestions + products.
   algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
     return {
       ...options,
       detachedMediaQuery: 'all',
       openOnFocus: true,
     };
   });

  // Customize individual product template
  algoliaShopify.hooks.registerHook('beforeAutocompleteProductTemplate', function(defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
    const { html, item, components } = templateOptions;

    if (typeof html !== 'function') {
      return defaultTemplate;
    }

    // Split title by " - " to get product title and variant title
    // [0] is product title, [1] is variant title (colour), [2] and beyond are disregarded
    const titleParts = item.title.split(' - ');
    const productTitle = titleParts[0] || item.title;
    const variantTitle = titleParts.length > 1 ? titleParts[1] : '';

    // Format price — Algolia stores as float dollars (e.g. 74.99), not cents
    function formatMoney(dollars) {
      const cents = Math.round(dollars * 100);
      return window.Shopify && window.Shopify.formatMoney
        ? window.Shopify.formatMoney(cents)
        : '$' + dollars.toFixed(2).replace(/\.00$/, '');
    }

    const priceNum = parseFloat(item.price);
    const price = !isNaN(priceNum) && priceNum > 0 ? formatMoney(priceNum) : '';

    // Compare-at price — only show if higher than current price
    const compareNum = parseFloat(item.compare_at_price);
    const hasCompare = !isNaN(compareNum) && compareNum > priceNum;
    const comparePrice = hasCompare ? formatMoney(compareNum) : '';
    const savePct = hasCompare ? Math.round((1 - priceNum / compareNum) * 100) : 0;

    return html`
      <a
        href=${itemLink}
        class="aa-ItemLink aa-ProductCard"
        onClick=${() => trackSearchAttribution(item)}
      >
        <div class="aa-ProductCard__image">
          <div class="aa-ProductCard__image-inner">
            <img
              src=${algoliaShopify.helpers.renderImage(item, 400).src}
              srcset=${algoliaShopify.helpers.renderImage(item, 400).srcset}
              sizes="(min-width: 1024px) 25vw, 50vw"
              alt=${item.title}
            />
          </div>
        </div>
        <div class="aa-ProductCard__info">
          <div class="aa-ProductCard__title">${productTitle}</div>
          ${variantTitle ? html`<div class="aa-ProductCard__variant">${variantTitle}</div>` : ''}
          ${price ? html`
            <div class="aa-ProductCard__price-row">
              <span class="aa-ProductCard__price${hasCompare ? ' aa-ProductCard__price--sale' : ''}">${price}</span>
              ${hasCompare ? html`<span class="aa-ProductCard__compare">${comparePrice}</span>` : ''}
              ${hasCompare ? html`<span class="aa-ProductCard__save">SAVE ${savePct}%</span>` : ''}
            </div>
          ` : ''}
        </div>
      </a>
    `;
  });

  // Add "See All" footer button
  algoliaShopify.hooks.registerHook('beforeAutocompleteFooterTemplate', function(defaultTemplate, templateOptions, items, query) {
    const { html } = templateOptions;

    if (typeof html !== 'function' || !query || query.trim() === '') {
      return null;
    }

    return html`
      <div class="aa-Footer">
        <a href=${`/search?q=${encodeURIComponent(query)}`} class="aa-ViewAllLink">
          View all "${query}"
        </a>
      </div>
    `;
  });

  // Customize individual query suggestion items
  algoliaShopify.hooks.registerHook('beforeAutocompleteSuggestionsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, item, components } = templateOptions;

    return html`
      <a
        class="aa-ItemLink aa-SuggestionItem"
        href="${window.Shopify.routes.root}search?q=${encodeURIComponent(item.query)}"
      >
        ${components.Highlight({ hit: item, attribute: 'query' })}
      </a>
    `;
  });

  // Customize main template layout with query suggestions and products
  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html } = templateOptions;

    // Detect empty query by reading the active Algolia input value
    const query = ((document.querySelector('.aa-DetachedFormContainer .aa-Input') ||
                    document.querySelector('.aa-Input') || {}).value || '').trim();

    if (!query) {
      // ── Empty state: Trending Searches + Recently Viewed / Trending Products ──
      const trending = (window.MNNav && window.MNNav.trendingSearches) || [];
      let recentlyViewed = [];
      try { recentlyViewed = JSON.parse(localStorage.getItem('mn_recently_viewed_v3') || '[]'); } catch (e) {}
      const trendingProducts = (window.MNNav && window.MNNav.trendingProducts) || [];

      if (!trending.length && !recentlyViewed.length && !trendingProducts.length) return null;

      // Reuse the same panel structure as active search so card widths are identical
      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
          <div class="aa-PanelSections">
            <div class="aa-PanelSection--left">
              ${trending.length > 0 && html`
                <div class="aa-SourceHeader aa-SourceHeader-display">
                  <span class="aa-SourceHeaderTitle aa-sourceHeaderTitle-display">TRENDING SEARCHES</span>
                </div>
                <ul class="aa-EmptyState__list">
                  ${trending.map(item => html`
                    <li class="aa-EmptyState__item">
                      <a href=${item.url || '/search?q=' + encodeURIComponent(item.text)} class="aa-EmptyState__link">
                        ${item.text}
                      </a>
                    </li>
                  `)}
                </ul>
              `}
            </div>
            <div class="aa-PanelSection--right">
              ${recentlyViewed.length > 0 ? html`
                <div class="aa-SourceHeader aa-SourceHeader-display">
                  <span class="aa-SourceHeaderTitle aa-sourceHeaderTitle-display">RECENTLY VIEWED</span>
                </div>
                <div class="aa-EmptyState__products">
                  ${recentlyViewed.slice(0, 4).map(item => {
                    const rvParts = item.title.split(' - ');
                    const rvTitle = rvParts[0] || item.title;
                    const rvSubtitle = rvParts.length > 1 ? rvParts[1] : '';
                    return html`
                    <a href=${item.url} class="aa-EmptyState__product">
                      <div class="aa-EmptyState__product-img">
                        <img src=${item.image} alt=${item.title} loading="lazy" />
                      </div>
                      <div class="aa-EmptyState__product-info">
                        <div class="aa-EmptyState__product-title">${rvTitle}</div>
                        ${rvSubtitle && html`<div class="aa-EmptyState__product-variant">${rvSubtitle}</div>`}
                        ${item.price && html`<div class="aa-EmptyState__product-price">${item.price}</div>`}
                      </div>
                    </a>
                  `})}
                </div>
              ` : trendingProducts.length > 0 ? html`
                <div class="aa-SourceHeader aa-SourceHeader-display">
                  <span class="aa-SourceHeaderTitle aa-sourceHeaderTitle-display">TRENDING PRODUCTS</span>
                </div>
                <div class="aa-EmptyState__products">
                  ${trendingProducts.slice(0, 4).map(item => {
                    const tpParts = item.title.split(' - ');
                    const tpTitle = tpParts[0] || item.title;
                    const tpSubtitle = tpParts.length > 1 ? tpParts[1] : '';
                    return html`
                    <a href=${item.url} class="aa-EmptyState__product">
                      <div class="aa-EmptyState__product-img">
                        <img src=${item.image} alt=${item.title} loading="lazy" />
                      </div>
                      <div class="aa-EmptyState__product-info">
                        <div class="aa-EmptyState__product-title">${tpTitle}</div>
                        ${tpSubtitle && html`<div class="aa-EmptyState__product-variant">${tpSubtitle}</div>`}
                        ${item.price && html`<div class="aa-EmptyState__product-price">${item.price}</div>`}
                      </div>
                    </a>
                  `})}
                </div>
              ` : ''}
            </div>
          </div>
        </div>
      `;
    }

    // ── Normal two-column layout (query has text) ──
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSections">
          <div class="aa-PanelSection--left">
            ${displaySuggestions &&
              html`
                <div class="aa-SourceHeader aa-SourceHeader-display">
                  <span class="aa-SourceHeaderTitle aa-sourceHeaderTitle-display">SUGGESTIONS</span>
                </div>
                ${elements.querySuggestionsPlugin}
              `}
          </div>
          <div class="aa-PanelSection--right">
            ${elements.products &&
              html`
                <div class="aa-SourceHeader aa-SourceHeader-display">
                  <span class="aa-SourceHeaderTitle aa-sourceHeaderTitle-display">PRODUCTS</span>
                </div>
                ${elements.products}
              `}
          </div>
        </div>
      </div>
    `;
  });

  // Transform product response to ensure we get products not variants
  algoliaShopify.hooks.registerHook('beforeAutocompleteProductTransformResponseHits', function(hits) {
    // Group variants by product and return only unique products
    const productsMap = new Map();

    hits.forEach(hit => {
      const productId = hit.product_id || hit.objectID;
      if (!productsMap.has(productId)) {
        productsMap.set(productId, hit);
      }
    });

    return Array.from(productsMap.values()).slice(0, 4);
  });

});


/* Ensure the overlay is always a direct child of <body> and the last one.
   On mobile, offsets the overlay below the sticky nav so the header stays visible.
   Watches both body childList (React portals re-appending) and body class
   attribute (aa-Detach toggled) to move/reposition the overlay at the right moment. */
(function () {
  function ensureOverlayOnTop() {
    var overlay = document.querySelector('.aa-DetachedOverlay');
    if (!overlay) return;
    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
    if (document.body.lastElementChild !== overlay) {
      document.body.appendChild(overlay);
    }

    // On mobile: push overlay below the sticky header so the nav stays visible
    if (window.innerWidth < 1024) {
      var header = document.querySelector('.mn-header');
      var offsetPx = header ? Math.round(header.getBoundingClientRect().bottom) : 56;
      var offset = offsetPx + 'px';
      overlay.style.setProperty('top', offset, 'important');
      var container = overlay.querySelector('.aa-DetachedContainer');
      if (container) {
        container.style.setProperty('top', offset, 'important');
        container.style.setProperty('max-height', 'calc(100vh - ' + offset + ')', 'important');
      }
    }
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'attributes' || m.type === 'childList') {
        ensureOverlayOnTop();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    attributes: true,
    attributeFilter: ['class']
  });
})();
